import React from "react";
import logo from "../../components/assets/addmecart.png";
import Footer from "../Fotter";

const ContactUs = () => {
  return (
    <div className="flex flex-col min-h-screen bg-white text-gray-800">
      <header className="p-6 border-b flex justify-center bg-white shadow-sm">
        <img loading="lazy" src={logo} alt="addmecart Logo" className="h-24 object-contain" />
      </header>

      <main className="flex-grow flex items-center justify-center px-4 py-10">
        <div className="w-[90%] bg-white  p-6 md:p-10 ">
          <h1 className="text-4xl font-bold mb-8 text-center text-black">
            Contact Us
          </h1>

          <div className="space-y-6 text-lg leading-relaxed ">
            <div>
              <h2 className=" font-bold"> Office and Warehouse Location:</h2>
              <p>
                THAKUR JI KI HAWELI JALPA MATA MANDIR KE PASS RAJGARH Rajgarh Madhya Pradesh, Bharat Pin 465661
              </p>
            </div>

            <div>
              <h2 className="font-bold"> Registered Address:</h2>
              <p>
                Jai Stambh Chowk ,opposite Gurh Gali ,Rajgarh , Rajgarh Madhya Pradesh, Bharat ,Pin – 465661
              </p>
            </div>

            <div>
              <h2 className="font-bold"> Email:</h2>
              <p classname="hover:text-blue-600">info@addmecart.com </p>

              <p>(We try to reply to every query within 24 working hours)</p>
            </div>

            <div>
              <h2 className="font-bold"> Call:</h2>
              <p> 08062689340</p>
            </div>

            <div>
              <h2 className="font-bold"> Website:</h2>
              <p>https://www.addmecart.com</p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ContactUs;
